import { render, staticRenderFns } from "./JobDescriptionsFormPage.vue?vue&type=template&id=297f8a4f&"
import script from "./JobDescriptionsFormPage.vue?vue&type=script&lang=js&"
export * from "./JobDescriptionsFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports